if ($('.image-txt__slide').length) {
  $(window).on('scroll load', function () {
    var pixels = window.scrollY * 0.3;
    $('.image-txt__slide--left').css({
      transform: 'translateX(-' + pixels + 'px)',
    });

    $('.image-txt__slide--center').css({
      transform: 'translateX(' + pixels + 'px)',
    });

    $('.image-txt__slide--right').css({
      transform: 'translateX(-' + pixels + 'px)',
    });
  });
}
